import { Link as ScrollLink } from 'react-scroll';
// material
import { styled } from '@material-ui/core/styles';
import { Grid, Link, Divider, Container, Typography, Stack } from '@material-ui/core';
//
import Logo from '../../components/Logo';

// ----------------------------------------------------------------------

const LINKS = [
  {
    headline: 'LLanquihue',
    children: [
      { name: 'Nosotros', href: 'https://www.cafellanquihue.com/nosotros/' },
      { name: 'Contactanos', href: 'https://www.cafellanquihue.com/contactanos/' },
      { name: 'Tienda', href: 'https://www.cafellanquihue.com/tienda' }
    ]
  },
  {
    headline: 'Contacto',
    children: [
      { name: 'quiero@cafellanquihue.com', href: 'mailto:quiero@cafellanquihue.com' },
      { name: 'San Bernardo N°342, Puerto Varas, Chile' }
    ]
  }
];

const RootStyle = styled('div')(({ theme }) => ({
  position: 'relative',
  backgroundColor: theme.palette.background.default
}));

// ----------------------------------------------------------------------

export default function MainFooter() {
  const currentYear = new Date().getFullYear();
  return (
    <RootStyle>
      <Divider />
      <Container maxWidth="lg" sx={{ pt: 4 }}>
        <Grid
          container
          justifyContent={{ xs: 'center', md: 'space-between' }}
          sx={{ textAlign: { xs: 'center', md: 'left' } }}
        >
          <Grid item xs={12} sx={{ mb: 3 }}>
            <ScrollLink to="move_top" spy smooth>
              <Logo sx={{ mx: { xs: 'auto', md: 'inherit' } }} />
            </ScrollLink>
          </Grid>
          <Grid item xs={8} md={3}>
            <Typography variant="body2" sx={{ pr: { md: 5 } }}>
              Tostamos los mejores granos de café para que lo puedas disfrutar en cualquier momento
              del día.
            </Typography>
          </Grid>

          <Grid item xs={12} md={7}>
            <Stack
              spacing={5}
              direction={{ xs: 'column', md: 'row' }}
              justifyContent="space-between"
            >
              {LINKS.map((list) => {
                const { headline, children } = list;
                return (
                  <Stack key={headline} spacing={2}>
                    <Typography component="p" variant="overline">
                      {headline}
                    </Typography>
                    {children.map((link) => (
                      <Link href={link.href} key={link.name} color="inherit" target="_blank">
                        {link.name}
                      </Link>
                    ))}
                  </Stack>
                );
              })}
            </Stack>
          </Grid>
        </Grid>

        <Typography
          component="p"
          variant="body2"
          sx={{
            mt: 10,
            pb: 5,
            fontSize: 13,
            textAlign: { xs: 'center', md: 'left' }
          }}
        >
          © {currentYear}. Todos los derechos reservados
        </Typography>
      </Container>
    </RootStyle>
  );
}
